import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ExtensiveAttributeDefinitionReadState } from './extensive-attribute-definition-read.slice';
import { selectAllExtensiveAttributeDefinition } from './extensive-attribute-definition-read.adapter';

const selectSelf = (state: RootState) => state;
const getExtensiveAttributeDefinitionState = createSelector(selectSelf, (state) => state.extensiveAttributeDefinitionRead);

const getLoaded = createSelector(
  getExtensiveAttributeDefinitionState,
  (state: ExtensiveAttributeDefinitionReadState) => state.loaded,
);

const getExtensiveAttributeDefinitions = createSelector(
  selectSelf,
  (state: RootState) => selectAllExtensiveAttributeDefinition(state),
);

export const extensiveAttributeDefinitionReadQuery = {
  getLoaded,
  getExtensiveAttributeDefinitions,
};
